import React, { useMemo } from 'react';
import { LazyHydrate } from '@hotelplan/components.common.lazy-render';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import { FdrGeoContentQuery } from 'schemas/query/geo/fdr-geo-content.generated';
import { getGeoComponentOrder } from './fdr-geo.constants';
import { TFdrThGeoModuleObject } from './fdr-geo.types';
import { useGeoComponentsMap } from './useGeoComponentsMap';

type IFdrGeoContentProps = {
  id: string;
  isCountry: boolean;
  geo: FdrGeoContentQuery['fdrGeo'];
  isB2B: boolean;
  geoModules: TFdrThGeoModuleObject;
  isNewMapDesignEnabled: boolean;
  pageComponents: FdrPageComponentsFragment['components'];
  geoStaticPageComponents: FdrPageComponentsFragment['components'];
};

const FdrGeoContent: React.FC<IFdrGeoContentProps> = ({
  id,
  isCountry,
  geo,
  isB2B,
  geoModules,
  isNewMapDesignEnabled,
  pageComponents,
  geoStaticPageComponents,
}: IFdrGeoContentProps) => {
  const geoStaticComponentsMap = useGeoComponentsMap(
    id,
    isCountry,
    geo,
    isB2B,
    geoModules,
    isNewMapDesignEnabled,
    pageComponents,
    geoStaticPageComponents
  );

  const content = useMemo(() => {
    const order = getGeoComponentOrder(id);

    return order.map((e, i) => {
      return (
        <React.Fragment key={i}>
          {geoStaticComponentsMap.get(e)?.()}
        </React.Fragment>
      );
    });
  }, [id, geoStaticComponentsMap]);

  return (
    <LazyHydrate whenIdle={true} whenVisible={true}>
      <>{content}</>
    </LazyHydrate>
  );
};

export default FdrGeoContent;
